import React, { useState, Fragment, useRef, useEffect } from "react";
import Header from "./AuthLayout/Header";
import { images } from "constants";
import Bot from "components/modal/Bot";
import Footer from "./AuthLayout/Footer";

import LandingPageHeader from "./NonAuthLayout/LandingPageHeader";
import SideBar from "components/layout/SideBar";
import { useLocation, Outlet } from "react-router-dom";
import SmallFooter from "./AuthLayout/SmallFooter";
import Toast from "components/toast/toast";

import { connectSocket } from "utils/socket";

const ReportDropdown = ({ setShow }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className="fixed z-[15] bottom-20 md:bottom-40 right-5"
      ref={dropdownRef}
    >
      {/* Trigger Button */}
      <div>
        <button
          className="block z-30 w-fit ml-auto"
          onClick={() => setIsOpen(!isOpen)}
        >
          <img src={images.bot} alt="bot" />
        </button>

        {/* Dropdown Menu */}
        {isOpen && (
          <div className="relative mt-6 py-2 w-48 bg-white-100 border border-black-100/10 shadow-custom  rounded-lg overflow-visible">
            {/* Triangle Pointer */}
            <div className="absolute -top-4 right-2 translate-y-full">
              <div className="w-4 h-4 bg-white-100 transform rotate-45 -translate-y-2  border-t border-l border-black-100/10 " />
            </div>

            {/* Report a problem */}
            <a
              onClick={() => setIsOpen(!isOpen)}
              href="https://forms.gle/eU5RtWkaFosqeV1S6"
              target="_blank"
              className=" w-full px-4 py-3 text-left hover:bg-gray-50/30 flex items-center gap-3"
              rel="noreferrer"
            >
              <div className="text-[#667085]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <span className="text-gray-600 text-sm font-medium">
                Report a problem
              </span>
            </a>

            {/* Chat with us */}
            <button
              onClick={() => setShow((prev) => !prev)}
              className=" border-t border-black-100/10 w-full px-4 py-3 text-left hover:bg-gray-50/30 flex items-center gap-3"
            >
              <div className="text-[#667085]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                  />
                </svg>
              </div>
              <span className="text-gray-600 text-sm font-medium">
                Chat with us
              </span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export const AuthLayout = ({ children }) => {
  const location = useLocation();
  const [show, setShow] = useState(false);

  //connect socket when authenticated
  useEffect(() => {
    connectSocket();
  }, []);

  return (
    <Fragment>
      <div className="overflow-x-hidden w-full bg-primary-100">
        <div className="overflow-x-hidden w-full mx-auto relative">
          <Header />
          <div
            className={`min-h-screen md:pt-[125px]  pt-[88px] lg:pb-0 ${
              location.pathname.includes("/plan-trip") ||
              location.pathname.includes("/customtrips")
                ? "bg-[#F5F7F9]"
                : "bg-[#fff]"
            }  max-w-[1440px] mx-auto ${
              location.pathname === "/chat" ||
              location.pathname === "/" ||
              location.pathname === "/plan-trip"
                ? ""
                : "px-[24px] md:px-[65px]"
            }`}
          >
            {children}
          </div>
          {location.pathname !== "/404" && (
            <div>
              {location.pathname === "/tripvault" ||
              location.pathname === "/profile" ||
              location.pathname.includes("/customtrips") ||
              location.pathname === "/support" ||
              location.pathname === "/transactions" ||
              location.pathname === "/coupons" ||
              location.pathname === "/referal" ? (
                <div className="lg:pl-[21%]">
                  <SmallFooter />
                </div>
              ) : location.pathname === "/chat" ? (
                <SmallFooter />
              ) : (
                <Footer />
              )}
            </div>
          )}

          <ReportDropdown setShow={setShow} />

          <Bot isOpen={show} onClose={() => setShow(false)} />
        </div>
      </div>
    </Fragment>
  );
};

export const NonAuthLayout = () => {
  const secondSectionRef = useRef(null);
  const location = useLocation();

  const handleClick = () => {
    secondSectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const isHomePage = location.pathname === "/";
  const isPackageLocation = location.pathname.includes("packages/location");
  const isAuthPage = location.pathname.includes("auth");
  const notFound = location.pathname.includes("404");

  // Home page layout
  if (isHomePage) {
    return (
      <div className="min-h-screen bg-primary-100">
        <Toast />
        <div className="mx-auto">
          <Outlet />
        </div>
      </div>
    );
  }

  // Package location layout
  if (isPackageLocation) {
    return (
      <div className="min-h-screen bg-white-100">
        <Toast />
        <LandingPageHeader />
        <div className="pt-[90px] mx-auto px-[3%] md:px-[6%] max-w-[1440px] 2xl:mx-auto">
          <Outlet />
        </div>
      </div>
    );
  }

  if (notFound) {
    return (
      <div className="min-h-screen bg-white-100">
        <div className="pt-[90px] mx-auto px-[3%] md:px-[6%] max-w-[1440px] 2xl:mx-auto">
          <Outlet />
        </div>
      </div>
    );
  }

  // Auth page layout
  if (isAuthPage) {
    return (
      <div className="lg:h-screen">
        <Toast />
        <div className="h-full grid grid-cols-1 lg:grid-cols-2">
          <SideBar handleClick={handleClick} />

          <div
            ref={secondSectionRef}
            className="h-full overflow-y-auto px-8 lg:px-16 py-10"
          >
            <Outlet />
          </div>
        </div>
      </div>
    );
  }

  // Default layout
  return (
    <div className="min-h-screen bg-primary-100">
      <Toast />
      <LandingPageHeader />
      <div className="pt-[90px] mx-auto">
        <Outlet />
      </div>
    </div>
  );
};
